






















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
@Component
export default class photoAlbum extends Vue {
  ImagePath: object = {};
  GetFolders () {
    this.$Api.PhotoAlbum.SearchFolders().then(result => {
      this.ImagePath = result.data.Data;
    });
  }

  get id () {
    return this.$route.params.id;
  }

  get isMobile () {
    return this.$store.state.isMobile;
  }

  get lang () {
    return this.$Storage.get('locale');
  }

  @Watch('isMobile', { deep: true })
  mounted () {
    this.GetFolders();
  }
}
